module.exports = __webpack_public_path__ + "public/images/generated-learn-to-sketch.aefd1f8b5a87927df7847555e61d3764.jpg";